import { render, staticRenderFns } from "./StudyItem.vue?vue&type=template&id=74f6b012&"
import script from "./StudyItem.vue?vue&type=script&lang=js&"
export * from "./StudyItem.vue?vue&type=script&lang=js&"
import style0 from "./StudyItem.vue?vue&type=style&index=0&id=74f6b012&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports